import React, { useEffect } from 'react';
import { FormikErrors, useFormik } from 'formik';
import { getRequirementConditionsAvailableOptions } from '../utils/getRequirementConditionsAvailableOptions';
import {
  AutomationActionType,
  CandidateStatus,
  RequirementConditionType
} from 'generated-graphql/types';
import { Box, Divider } from '@mui/material';
import { Button } from 'system/atoms';
import AddIcon from '@mui/icons-material/Add';
import { ActionSettingItem } from './ActionSettingItem';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

type Props = {
  candidateBatchId?: string;
  atsJobId?: string | null;
  onFormChange: (values: AutomationFormItem[]) => void;
  analysisAutomationItems: AutomationFormItem[];
  errors?: FormikErrors<AutomationFormItem>[];
  enableReinitialize: boolean;
};

export const ActionsSettings: React.FC<Props> = ({
  analysisAutomationItems,
  onFormChange,
  candidateBatchId,
  atsJobId,
  errors,
  enableReinitialize
}) => {
  const formik = useFormik<AutomationFormItem[]>({
    initialValues: analysisAutomationItems || [],
    onSubmit: onFormChange,
    enableReinitialize
  });

  useEffect(() => {
    onFormChange(formik.values);
  }, [formik.values]);

  const {
    candidateStatusesAvailableOptions:
      requirementConditionCandidateStatusAvailableOptions
  } = getRequirementConditionsAvailableOptions(formik.values);

  const addAutomation = () => {
    const defaultCandidateStatusCondition =
      requirementConditionCandidateStatusAvailableOptions.includes(
        CandidateStatus.ShortListed
      )
        ? CandidateStatus.ShortListed
        : requirementConditionCandidateStatusAvailableOptions[0];

    const newRules = [...analysisAutomationItems];

    const newRule: AutomationFormItem = {
      requirementConditions: [
        {
          type: RequirementConditionType.CandidateStatusCondition,
          candidateStatus: defaultCandidateStatusCondition
        }
      ],
      action: {
        type: AutomationActionType.SendCampaign,
        candidateStatus: undefined,
        campaignId: undefined
      }
    };
    newRules.push(newRule);

    formik.setValues(newRules);
  };

  const removeAutomationItem = (index: number) => {
    const newValues = formik.values.filter((_, i) => i !== index);
    formik.setValues(newValues);
  };

  return (
    <>
      {analysisAutomationItems.map((automationItem, index) => (
        <Box key={`action-${index}`} sx={{ mb: '15px' }}>
          <Box my="30px">
            <ActionSettingItem
              atsJobId={atsJobId}
              candidateBatchId={candidateBatchId}
              index={index}
              analysisAutomationItem={automationItem}
              setFieldValue={formik.setFieldValue}
              removeActionItem={() => removeAutomationItem(index)}
              errors={errors}
            />
          </Box>
          <Divider key={`divider-${automationItem.id}`} />
        </Box>
      ))}
      <Box alignSelf="start" mb="15px" mt="15px">
        <Button
          variant="tertiary"
          startIcon={<AddIcon />}
          onClick={addAutomation}
        >
          Add action
        </Button>
      </Box>
      <Divider />
    </>
  );
};
